__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sdm-app";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("next/dynamic", "14.2.32", function() { return __webpack_require__.e(4953).then(function() { return function() { return __webpack_require__(14953); }; }); });
			register("next/head", "14.2.32", function() { return __webpack_require__.e(3368).then(function() { return function() { return __webpack_require__(13368); }; }); });
			register("next/image", "14.2.32", function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(29965); }; }); });
			register("next/link", "14.2.32", function() { return Promise.all([__webpack_require__.e(4721), __webpack_require__.e(1106)]).then(function() { return function() { return __webpack_require__(91106); }; }); });
			register("next/router", "14.2.32", function() { return Promise.all([__webpack_require__.e(4721), __webpack_require__.e(7884), __webpack_require__.e(6715), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(86715); }; }); });
			register("next/script", "14.2.32", function() { return Promise.all([__webpack_require__.e(7884), __webpack_require__.e(8122), __webpack_require__.e(165)]).then(function() { return function() { return __webpack_require__(28133); }; }); });
			register("react-dom/client", "18.2.0", function() { return Promise.all([__webpack_require__.e(6593), __webpack_require__.e(8122)]).then(function() { return function() { return __webpack_require__(5338); }; }); });
			register("react-dom", "18.2.0", function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(40961); }; }); });
			register("react/jsx-runtime", "18.2.0", function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(74848); }; }); });
			register("react/jsx-runtime", "18.3.1", function() { return __webpack_require__.e(6100).then(function() { return function() { return __webpack_require__(56100); }; }); });
			register("react/jsx-runtime", "18.3.1", function() { return Promise.all([__webpack_require__.e(797), __webpack_require__.e(17)]).then(function() { return function() { return __webpack_require__(50017); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__(96540); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(5432).then(function() { return function() { return __webpack_require__(85432); }; }); });
			register("react", "18.3.1", function() { return __webpack_require__.e(2757).then(function() { return function() { return __webpack_require__(65138); }; }); });
			register("styled-jsx/style", "5.1.1", function() { return __webpack_require__.e(2513).then(function() { return function() { return __webpack_require__(32513); }; }); });
			register("styled-jsx", "5.1.1", function() { return __webpack_require__.e(6816).then(function() { return function() { return __webpack_require__(36816); }; }); });
			initExternal(49542);
			initExternal(26227);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};